import { useState } from "react";
import logo from "../../assets/iRise-psychology-Logo1.png";

export default function BenNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="benNavShell sticky-top">
      <nav className="benNavBar">
        <div className="main-wrap benNavInner">

          <div className="benNavLeft">
            <a className="benNavBrand" href="#intro">
              <img
                src={logo}
                alt="iRise Psychology"
                className="benNavLogo"
              />
            </a>
          </div>

          <div className="benNavCentre">
            <p className="benNavTitle m-0 p-0">DR BENJAMIN PIPER</p>
            <p className="benNavSubtitle m-0 p-0 text-muted">
              Counselling Psychologist and Clinical Director
            </p>
          </div>

          <div className="benNavRight">
            <button
              type="button"
              className="benNavContactBtn"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              Menu
            </button>

            {menuOpen && (
              <div className="benNavDropdown">
                <a href="#intro" onClick={() => setMenuOpen(false)}>Intro</a>
                <a href="#about" onClick={() => setMenuOpen(false)}>About</a>
                        <a href="#experience" onClick={() => setMenuOpen(false)}>Experience</a>
                <a href="#services" onClick={() => setMenuOpen(false)}>Services</a>
                <a href="#appointments" onClick={() => setMenuOpen(false)}>Appointments</a>
                <a href="#fees" onClick={() => setMenuOpen(false)}>Fees</a>
                <a href="#reviews" onClick={() => setMenuOpen(false)}>Reviews</a>
                <a href="#contact" onClick={() => setMenuOpen(false)}>Contact</a>
              </div>
            )}
          </div>

        </div>
      </nav>
    </header>
  );
}